import { z } from 'zod';

export const fundSchema = z.object({
  name: z.string().min(1, 'Fund name is required'),
  code: z.string().min(1, 'Fund code is required'),
  pricePerUnit: z.number().min(0, 'Price per unit must be 0 or greater'),
  amcPercentage: z.number().min(0, 'Annual management charge must be 0 or greater'),
});

export type EditableFund = z.infer<typeof fundSchema>;
